var map = {
	"./1024px.png": 359,
	"./1366px.png": 360,
	"./1600px.png": 361,
	"./1920px.png": 362,
	"./320px.png": 363,
	"./768px.png": 364
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids-behaviour ^\.\/.*\.png$
// module id = 819
// module chunks = 0